import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropdocsModal from '../../../components/modal/PropdocsModal';
import { DocumentTemplateModalComponentProps } from './DocumentTemplateModalContainer';

const DocumentTemplateModal = ({ isOpen, onClose, modalFilters }: DocumentTemplateModalComponentProps) => {
  return (
    <PropdocsModal
      show={isOpen}
      setShow={onClose}
      size="xl"
      title={
        <header>
          <FormattedMessage id="title.first-lease-template" defaultMessage="Select a Template" />
        </header>
      }
    >
      <>{modalFilters || <div></div>}</>
    </PropdocsModal>
  );
};

export default DocumentTemplateModal;
